import { useAppDispatch } from "../../../../redux/hooks";

import { CellsNomenclatureListInterface } from "../../../../redux/interfaces/admin.interface";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import { adminRoutes } from "../../../../router/routesConstants";
import {
  fetchDeleteCellNomenclature,
  getPrintCellNomenclature,
} from "../../../../redux/api/admin.api";

function CellsNomenclatureActionButton({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: CellsNomenclatureListInterface;
}) {
  const dispatch = useAppDispatch();

  const { idCelula } = crudData;

  const handleDeleteCellNomenclature = () => {
    dispatch(
      fetchDeleteCellNomenclature({
        idCelula: idCelula,
      }),
    );
  };

  const goToUpdateCellNomenclature = () => {
    if (idCelula) {
      return `${itemId}/${adminRoutes.editCellNomenclature}?idCelula=${idCelula}`;
    }
  };

  const handleDownloadBarCodeOfCell = () => {
    dispatch(
      getPrintCellNomenclature({
        idCelula: idCelula,
      }),
    );
  };

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={`Celula ${crudData.adresa || crudData.alias || crudData.celula}`}
      ariaLabel={`Actiuni pentru celula ${crudData.adresa || idCelula}`}
      items={[
        {
          id: "edit",
          label: "Editeaza",
          icon: "EDIT",
          tooltip: "Modifica datele si caracteristicile celulei.",
          navigate: goToUpdateCellNomenclature(),
        },
        {
          id: "print",
          label: "Printeaza",
          icon: "PRINT",
          kind: "download",
          tooltip:
            "Descarca PDF-ul cu codul de bare al celulei pentru tiparire.",
          withConfirmationModal: {
            modalTitle: `Doriti sa tipariti codul de bare pentru celula curenta?`,
            modalLeftButtonVariant: "outlined",
            modalRightButtonOnClick: handleDownloadBarCodeOfCell,
          },
        },
        {
          id: "delete",
          dividerBefore: true,
          label: "Sterge",
          icon: "DELETE",
          color: "error",
          tooltip: "Sterge celula selectata dupa confirmare.",
          withConfirmationModal: {
            modalLeftButtonVariant: "outlined",
            modalTitle: `Doriti sa stergeti celula ?`,
            modalRightButtonOnClick: handleDeleteCellNomenclature,
          },
        },
      ]}
    />
  );
}

export default CellsNomenclatureActionButton;
